import React from 'react'
import MaterialSymbol from '../material-symbol'

const MoreVert = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="more_vert" {...props} />
))

MoreVert.displayName = 'MoreVert'

export default MoreVert
